
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/[...paths]",
      function () {
        return require("private-next-pages/[lang]/[...paths]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/[...paths]"])
      });
    }
  